import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  container: ({ width, maxInlineWidth }: { maxInlineWidth: number | string; width: number | string }) => ({
    maxWidth: "100%",
    verticalAlign: "middle",
    width: width,
    maxInlineSize: maxInlineWidth,
  }),
});
